import { all, call, put, retry, takeEvery } from 'redux-saga/effects';
import { siteActions } from '../actions';
import { Site } from '../modules/site/types';
import ACTIONS from '../app.constants';
import { Api, API_CONFIGURATIONS } from '../services/services';
import { getAccessToken } from './authentication.sagas';

function* getSite() {
    try {
        yield put(siteActions.getSite.pending);

        const site: Site = yield retry(
            API_CONFIGURATIONS.MAX_RETRY_COUNT,
            API_CONFIGURATIONS.RETRY_INTERVAL,
            Api.getSite,
        );

        yield put(siteActions.getSite.success(site));
    } catch (error) {
        yield put(siteActions.getSite.error(error));
    }
}

export function* getAuthenticationToken(action: any) {
    try {
        const token: string = yield call(getAccessToken, 'licenses.read');
        action.payload.callback(token);
    } catch (error) {}
}
export function* getCitationsAuthenticationToken(action: any) {
    try {
        const token: string = yield call(getAccessToken, 'citations.write');
        action.payload.callback(token);
    } catch (error) {
        yield put(siteActions.getSite.error(error));
    }
}

export default function* rootSaga() {
    yield call(getSite);
    yield all([takeEvery(ACTIONS.GET_AUTHENTICATION_TOKEN, getAuthenticationToken)]);
    yield all([takeEvery(ACTIONS.GET_CITATIONS_AUTHENTICATION_TOKEN, getCitationsAuthenticationToken)]);
}
